import { css } from "emotion";

export const submitButton = css`
    background-color: #4e9bac;
    color: #fff;
    border: none;
    padding: 6px 13px;
    font-family: AvenirLTStd45Book;
    font-weight: 700;
    font-size: 18px;
    margin: 15px 5px;
    cursor: pointer;
    &:hover {
        background-color: #33899c;
    }
    &.link {
        background-color: transparent;
        color: #4e9bac;
        padding: 0;
        font-weight: 400;
        font-size: 14px;
        margin: 0 0 5px 0;
        &:hover {
            color: #33899c;
        }
    }
`;